import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaintBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"paint-bucket, design, color, appearance"} maskId="square-filled-radius-0-stroke-1-IconPaintBucket"><path fillRule="evenodd" clipRule="evenodd" d="M12 2C16.4183 2 20 5.58172 20 10H21V11H20V22H4V11H3V10H4C4 5.58172 7.58172 2 12 2ZM12 3C8.13401 3 5 6.13401 5 10H8V15H9V10H10V13H11V10H19C19 6.13401 15.866 3 12 3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconPaintBucket;
